module.exports = __webpack_public_path__ + "img/2x.e9f7217.jpg";